import { render, staticRenderFns } from "./EdDescriptions.vue?vue&type=template&id=6999d90a&scoped=true&"
import script from "./EdDescriptions.vue?vue&type=script&lang=jsx&"
export * from "./EdDescriptions.vue?vue&type=script&lang=jsx&"
import style0 from "./EdDescriptions.vue?vue&type=style&index=0&id=6999d90a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999d90a",
  null
  
)

export default component.exports